// extracted by mini-css-extract-plugin
module.exports = {"root":"FeaturedShowPoster__root_fJJUn","image":"FeaturedShowPoster__image_337w1"};